var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { computed, makeObservable } from 'mobx';
import { alias, child } from '../../../utils/serializr/serializr';
import { TopicSubtopics } from './modules/TopicSubtopics';
import { Location } from '../location/Location';
import { TopicInfo } from './modules/TopicInfo';
import { TopicMiniQuestions } from './modules/TopicMiniQuestions';
import { TopicStore } from './modules/TopicStore';
import { TopicMicroQuestions } from './modules/TopicMicroQuestions';
import { runtime } from '../../runtime/Runtime';
import { memoize } from '../../../utils/mobx/decorators/memoize';
import { withInit } from '../../../utils/serializr/schema/middle/withInit';
import { primitive } from '../../../utils/serializr/schema/inner/primitive';
import { editable } from '../../../utils/mobx/decorators/editable';
import { json } from '../../../utils/serializr/schema/inner/json';
import { uniq } from '../../../utils/helper/lodash_replacements';
import { TopicMiniQuestionsHidden } from './modules/TopicMiniQuestionsHidden';
import { FunnelType } from '../../learnware/LearnwareEnums';
import { TopicLevels } from './modules/TopicLevels';
import { TopicFilter } from './modules/TopicFilter';
export class Topic extends Location {
    type = 'topic';
    isDatabaseEntity = true;
    constructor(init) {
        super(init);
        makeObservable(this);
    }
    get app() {
        return this.parent;
    }
    get importingChildren() {
        return super.importingChildren.concat(this.locationSteps.allSteps);
    }
    get id() {
        return super.id;
    }
    set id(id) {
        this.id_raw = id;
    }
    name_raw = '';
    count = 0;
    average = 0.66;
    activity = 80;
    isPublic = 1; // alias public
    games = 'reward,grade';
    meta = 0;
    voc = 0;
    depreciated = 0;
    orderposition = 0;
    linking = 0;
    funnel = FunnelType.Standard;
    rating = 0;
    maxRating = 0;
    copy_of = null;
    duplicate_of = null;
    pointsperminute = 2.2;
    theoryUrl = '';
    theoryUrl2 = '';
    vgwort_id = null;
    vgwort_mode = 0;
    tts = 'no';
    klassenarbeiten_topics = '0';
    klassenarbeiten_subtopics = '0';
    parent_topic_id1 = null;
    parent_topic_id2 = null;
    parent_topic_id3 = null;
    parent_topic_id4 = null;
    parent_topic_id5 = null;
    parent_topic_id6 = null;
    parent_topic_id7 = null;
    parent_topic_id8 = null;
    parent_topic_id9 = null;
    parent_topic_id10 = null;
    parent_topic_id11 = null;
    parent_topic_id12 = null;
    parent_topic_id13 = null;
    parent_topic_id14 = null;
    parent_topic_id15 = null;
    parent_topic_id16 = null;
    parent_topic_id17 = null;
    parent_topic_id18 = null;
    parent_topic_id19 = null;
    parent_topic_id20 = null;
    parent_topic_recursive1 = 0;
    parent_topic_recursive2 = 0;
    parent_topic_recursive3 = 0;
    parent_topic_recursive4 = 0;
    parent_topic_recursive5 = 0;
    parent_topic_recursive6 = 0;
    parent_topic_recursive7 = 0;
    parent_topic_recursive8 = 0;
    parent_topic_recursive9 = 0;
    parent_topic_recursive10 = 0;
    parent_topic_recursive11 = 0;
    parent_topic_recursive12 = 0;
    parent_topic_recursive13 = 0;
    parent_topic_recursive14 = 0;
    parent_topic_recursive15 = 0;
    parent_topic_recursive16 = 0;
    parent_topic_recursive17 = 0;
    parent_topic_recursive18 = 0;
    parent_topic_recursive19 = 0;
    parent_topic_recursive20 = 0;
    parent_topic_importmode1 = 0;
    parent_topic_importmode2 = 0;
    parent_topic_importmode3 = 0;
    parent_topic_importmode4 = 0;
    parent_topic_importmode5 = 0;
    parent_topic_importmode6 = 0;
    parent_topic_importmode7 = 0;
    parent_topic_importmode8 = 0;
    parent_topic_importmode9 = 0;
    parent_topic_importmode10 = 0;
    parent_topic_importmode11 = 0;
    parent_topic_importmode12 = 0;
    parent_topic_importmode13 = 0;
    parent_topic_importmode14 = 0;
    parent_topic_importmode15 = 0;
    parent_topic_importmode16 = 0;
    parent_topic_importmode17 = 0;
    parent_topic_importmode18 = 0;
    parent_topic_importmode19 = 0;
    parent_topic_importmode20 = 0;
    relevant_topic_id1 = 0;
    relevant_topic_id2 = 0;
    relevant_topic_id3 = 0;
    relevant_topic_id4 = 0;
    relevant_topic_id5 = 0;
    relevant_topic_id6 = 0;
    relevant_topic_id7 = 0;
    relevant_topic_id8 = 0;
    relevant_topic_id9 = 0;
    relevant_topic_id10 = 0;
    isPremium = false;
    isSpeech = false;
    topicStore;
    get subtopics() {
        return this.topicSubtopics.subtopics;
    }
    get topicMicroQuestions() {
        return new TopicMicroQuestions(this);
    }
    get topicMiniQuestions() {
        return new TopicMiniQuestions(this);
    }
    get topicMiniQuestionsHidden() {
        return new TopicMiniQuestionsHidden(this);
    }
    get topicSubtopics() {
        return new TopicSubtopics(this);
    }
    get topicFilter() {
        return new TopicFilter(this);
    }
    get topicLevels() {
        return new TopicLevels(this);
    }
    get topicInfo() {
        return new TopicInfo(this);
    }
    storedSubtopics_fallback = [];
    storedSubtopics_foreign = [];
    get storedSubtopics() {
        if (this.storedSubtopics_foreign.length > 0) {
            return this.storedSubtopics_foreign;
        }
        if (this.topicSubtopics.storedSubtopics.length > 0) {
            return this.topicSubtopics.storedSubtopics;
        }
        return this.storedSubtopics_fallback;
    }
    set storedSubtopics(o) {
        if (this.storedSubtopics_fallback.length > 0) {
            // foreign save
            this.storedSubtopics_foreign = o;
        }
        this.storedSubtopics_fallback = o;
    }
    get topicEdit() {
        return new runtime.solidPackages.Edit.classes.TopicEdit(this);
    }
    get name() {
        return this.name_raw;
    }
    set name(n) {
        this.name_raw = n;
    }
    get pathname() {
        if (!this.locationSteps.areStepPathsLoaded) {
            return this.pathname_fallback;
        }
        return `${this.locationSteps.allSteps.map(step => step.name).join('/')}/${this.name}`;
    }
    set pathname(pn) {
        this.pathname_fallback = pn;
    }
    packages_fallback;
    get packages() {
        const packages = [];
        if (this.isBundleDataLoaded) {
            if (this.bundleNames.includes('Draft')) {
                packages.push('draft');
            }
            if (this.bundleNames.includes('Abfrager')) {
                packages.push('abfrager');
            }
            return packages.join(',');
        }
        return this.packages_fallback;
    }
    set packages(t) {
        this.packages_fallback = t;
    }
    get isBundleDataLoaded() {
        if (!this.actorBundles.areAllActiveBundlesAvailable)
            return false;
        return true;
    }
    get bundlesAuto() {
        if (this.isBundleDataLoaded) {
            const all = uniq(this.actorBundles.deepPreloadBundleIds.concat(...this.topicMicroQuestions.microQuestionsQuery.streamedRef.map(q => q.bundles.split(','))));
            return all.join(',');
        }
        return '';
    }
    bundles_fallback;
    bundles_hasUpdatedOnce;
    // no @computed because of hasUpdatedOnce mechanism !!!
    get bundles() {
        if (this.bundles_hasUpdatedOnce)
            return this.bundles_fallback; // once protection needed for simultanous edits on multiple tabs
        if (!this.bundles_hasUpdatedOnce && this.bundlesAuto) {
            this.bundles_fallback = this.bundlesAuto;
            this.bundles_hasUpdatedOnce = true;
        }
        return this.bundlesAuto || this.bundles_fallback;
    }
    set bundles(t) {
        this.bundles_fallback = t;
    }
    get bundleNamesAuto() {
        if (this.isBundleDataLoaded) {
            const all = uniq(this.actorBundles.deepPreloadBundleNames.concat(...this.topicMicroQuestions.microQuestionsQuery.streamedRef.map(q => q.bundleNames.split(','))));
            return all.join(',');
        }
        return '';
    }
    bundleNames_fallback;
    bundleNames_hasUpdatedOnce;
    // no @computed because of hasUpdatedOnce mechanism !!!
    get bundleNames() {
        if (this.bundleNames_hasUpdatedOnce)
            return this.bundleNames_fallback;
        if (!this.bundleNames_hasUpdatedOnce && this.bundleNamesAuto) {
            this.bundleNames_fallback = this.bundleNamesAuto;
            this.bundleNames_hasUpdatedOnce = true;
        }
        return this.bundleNamesAuto || this.bundleNames_fallback;
    }
    set bundleNames(t) {
        this.bundleNames_fallback = t;
    }
    hiddenInApp_cached;
    get hiddenInApp() {
        if (this.topicMicroQuestions.microQuestionsQuery.isAvailable) {
            const value = this.topicMicroQuestions.microQuestionsQuery.streamedRef.filter(q => q.appHide > 0).length;
            this.hiddenInApp_cached = value;
            return value;
        }
        return this.hiddenInApp_cached;
    }
    set hiddenInApp(h) {
        this.hiddenInApp_cached = h;
    }
    static get serializeInfo() {
        return {
            extends: Location.serializeInfo,
            props: {
                count: true,
                hiddenInApp: true,
                average: true,
                activity: true,
                name: true,
                isPublic: alias('public', primitive),
                games: true,
                meta: true,
                voc: true,
                depreciated: true,
                orderposition: true,
                linking: true,
                funnel: true,
                rating: true,
                maxRating: true,
                copy_of: true,
                duplicate_of: true,
                pointsperminute: true,
                theoryUrl: true,
                theoryUrl2: true,
                vgwort_id: true,
                vgwort_mode: true,
                klassenarbeiten_topics: true,
                klassenarbeiten_subtopics: true,
                tts: true,
                parent_topic_id1: true,
                parent_topic_id2: true,
                parent_topic_id3: true,
                parent_topic_id4: true,
                parent_topic_id5: true,
                parent_topic_id6: true,
                parent_topic_id7: true,
                parent_topic_id8: true,
                parent_topic_id9: true,
                parent_topic_id10: true,
                parent_topic_id11: true,
                parent_topic_id12: true,
                parent_topic_id13: true,
                parent_topic_id14: true,
                parent_topic_id15: true,
                parent_topic_id16: true,
                parent_topic_id17: true,
                parent_topic_id18: true,
                parent_topic_id19: true,
                parent_topic_id20: true,
                parent_topic_recursive1: true,
                parent_topic_recursive2: true,
                parent_topic_recursive3: true,
                parent_topic_recursive4: true,
                parent_topic_recursive5: true,
                parent_topic_recursive6: true,
                parent_topic_recursive7: true,
                parent_topic_recursive8: true,
                parent_topic_recursive9: true,
                parent_topic_recursive10: true,
                parent_topic_recursive11: true,
                parent_topic_recursive12: true,
                parent_topic_recursive13: true,
                parent_topic_recursive14: true,
                parent_topic_recursive15: true,
                parent_topic_recursive16: true,
                parent_topic_recursive17: true,
                parent_topic_recursive18: true,
                parent_topic_recursive19: true,
                parent_topic_recursive20: true,
                parent_topic_importmode1: true,
                parent_topic_importmode2: true,
                parent_topic_importmode3: true,
                parent_topic_importmode4: true,
                parent_topic_importmode5: true,
                parent_topic_importmode6: true,
                parent_topic_importmode7: true,
                parent_topic_importmode8: true,
                parent_topic_importmode9: true,
                parent_topic_importmode10: true,
                parent_topic_importmode11: true,
                parent_topic_importmode12: true,
                parent_topic_importmode13: true,
                parent_topic_importmode14: true,
                parent_topic_importmode15: true,
                parent_topic_importmode16: true,
                parent_topic_importmode17: true,
                parent_topic_importmode18: true,
                parent_topic_importmode19: true,
                parent_topic_importmode20: true,
                relevant_topic_id1: true,
                relevant_topic_id2: true,
                relevant_topic_id3: true,
                relevant_topic_id4: true,
                relevant_topic_id5: true,
                relevant_topic_id6: true,
                relevant_topic_id7: true,
                relevant_topic_id8: true,
                relevant_topic_id9: true,
                relevant_topic_id10: true,
                storedSubtopics: alias('cachedTags', withInit(json(), [])),
                topicStore: withInit(child(TopicStore), {}),
            },
        };
    }
}
__decorate([
    editable()
], Topic.prototype, "name_raw", void 0);
__decorate([
    editable()
], Topic.prototype, "count", void 0);
__decorate([
    editable()
], Topic.prototype, "average", void 0);
__decorate([
    editable()
], Topic.prototype, "activity", void 0);
__decorate([
    editable()
], Topic.prototype, "isPublic", void 0);
__decorate([
    editable()
], Topic.prototype, "games", void 0);
__decorate([
    editable()
], Topic.prototype, "meta", void 0);
__decorate([
    editable()
], Topic.prototype, "voc", void 0);
__decorate([
    editable()
], Topic.prototype, "depreciated", void 0);
__decorate([
    editable()
], Topic.prototype, "orderposition", void 0);
__decorate([
    editable()
], Topic.prototype, "linking", void 0);
__decorate([
    editable()
], Topic.prototype, "funnel", void 0);
__decorate([
    editable()
], Topic.prototype, "copy_of", void 0);
__decorate([
    editable()
], Topic.prototype, "duplicate_of", void 0);
__decorate([
    editable()
], Topic.prototype, "theoryUrl", void 0);
__decorate([
    editable()
], Topic.prototype, "theoryUrl2", void 0);
__decorate([
    editable()
], Topic.prototype, "tts", void 0);
__decorate([
    editable()
], Topic.prototype, "klassenarbeiten_topics", void 0);
__decorate([
    editable()
], Topic.prototype, "klassenarbeiten_subtopics", void 0);
__decorate([
    editable()
], Topic.prototype, "parent_topic_id1", void 0);
__decorate([
    editable()
], Topic.prototype, "parent_topic_id2", void 0);
__decorate([
    editable()
], Topic.prototype, "parent_topic_id3", void 0);
__decorate([
    editable()
], Topic.prototype, "parent_topic_id4", void 0);
__decorate([
    editable()
], Topic.prototype, "parent_topic_id5", void 0);
__decorate([
    editable()
], Topic.prototype, "parent_topic_id6", void 0);
__decorate([
    editable()
], Topic.prototype, "parent_topic_id7", void 0);
__decorate([
    editable()
], Topic.prototype, "parent_topic_id8", void 0);
__decorate([
    editable()
], Topic.prototype, "parent_topic_id9", void 0);
__decorate([
    editable()
], Topic.prototype, "parent_topic_id10", void 0);
__decorate([
    editable()
], Topic.prototype, "parent_topic_id11", void 0);
__decorate([
    editable()
], Topic.prototype, "parent_topic_id12", void 0);
__decorate([
    editable()
], Topic.prototype, "parent_topic_id13", void 0);
__decorate([
    editable()
], Topic.prototype, "parent_topic_id14", void 0);
__decorate([
    editable()
], Topic.prototype, "parent_topic_id15", void 0);
__decorate([
    editable()
], Topic.prototype, "parent_topic_id16", void 0);
__decorate([
    editable()
], Topic.prototype, "parent_topic_id17", void 0);
__decorate([
    editable()
], Topic.prototype, "parent_topic_id18", void 0);
__decorate([
    editable()
], Topic.prototype, "parent_topic_id19", void 0);
__decorate([
    editable()
], Topic.prototype, "parent_topic_id20", void 0);
__decorate([
    editable()
], Topic.prototype, "parent_topic_recursive1", void 0);
__decorate([
    editable()
], Topic.prototype, "parent_topic_recursive2", void 0);
__decorate([
    editable()
], Topic.prototype, "parent_topic_recursive3", void 0);
__decorate([
    editable()
], Topic.prototype, "parent_topic_recursive4", void 0);
__decorate([
    editable()
], Topic.prototype, "parent_topic_recursive5", void 0);
__decorate([
    editable()
], Topic.prototype, "parent_topic_recursive6", void 0);
__decorate([
    editable()
], Topic.prototype, "parent_topic_recursive7", void 0);
__decorate([
    editable()
], Topic.prototype, "parent_topic_recursive8", void 0);
__decorate([
    editable()
], Topic.prototype, "parent_topic_recursive9", void 0);
__decorate([
    editable()
], Topic.prototype, "parent_topic_recursive10", void 0);
__decorate([
    editable()
], Topic.prototype, "parent_topic_recursive11", void 0);
__decorate([
    editable()
], Topic.prototype, "parent_topic_recursive12", void 0);
__decorate([
    editable()
], Topic.prototype, "parent_topic_recursive13", void 0);
__decorate([
    editable()
], Topic.prototype, "parent_topic_recursive14", void 0);
__decorate([
    editable()
], Topic.prototype, "parent_topic_recursive15", void 0);
__decorate([
    editable()
], Topic.prototype, "parent_topic_recursive16", void 0);
__decorate([
    editable()
], Topic.prototype, "parent_topic_recursive17", void 0);
__decorate([
    editable()
], Topic.prototype, "parent_topic_recursive18", void 0);
__decorate([
    editable()
], Topic.prototype, "parent_topic_recursive19", void 0);
__decorate([
    editable()
], Topic.prototype, "parent_topic_recursive20", void 0);
__decorate([
    editable()
], Topic.prototype, "parent_topic_importmode1", void 0);
__decorate([
    editable()
], Topic.prototype, "parent_topic_importmode2", void 0);
__decorate([
    editable()
], Topic.prototype, "parent_topic_importmode3", void 0);
__decorate([
    editable()
], Topic.prototype, "parent_topic_importmode4", void 0);
__decorate([
    editable()
], Topic.prototype, "parent_topic_importmode5", void 0);
__decorate([
    editable()
], Topic.prototype, "parent_topic_importmode6", void 0);
__decorate([
    editable()
], Topic.prototype, "parent_topic_importmode7", void 0);
__decorate([
    editable()
], Topic.prototype, "parent_topic_importmode8", void 0);
__decorate([
    editable()
], Topic.prototype, "parent_topic_importmode9", void 0);
__decorate([
    editable()
], Topic.prototype, "parent_topic_importmode10", void 0);
__decorate([
    editable()
], Topic.prototype, "parent_topic_importmode11", void 0);
__decorate([
    editable()
], Topic.prototype, "parent_topic_importmode12", void 0);
__decorate([
    editable()
], Topic.prototype, "parent_topic_importmode13", void 0);
__decorate([
    editable()
], Topic.prototype, "parent_topic_importmode14", void 0);
__decorate([
    editable()
], Topic.prototype, "parent_topic_importmode15", void 0);
__decorate([
    editable()
], Topic.prototype, "parent_topic_importmode16", void 0);
__decorate([
    editable()
], Topic.prototype, "parent_topic_importmode17", void 0);
__decorate([
    editable()
], Topic.prototype, "parent_topic_importmode18", void 0);
__decorate([
    editable()
], Topic.prototype, "parent_topic_importmode19", void 0);
__decorate([
    editable()
], Topic.prototype, "parent_topic_importmode20", void 0);
__decorate([
    editable()
], Topic.prototype, "relevant_topic_id1", void 0);
__decorate([
    editable()
], Topic.prototype, "relevant_topic_id2", void 0);
__decorate([
    editable()
], Topic.prototype, "relevant_topic_id3", void 0);
__decorate([
    editable()
], Topic.prototype, "relevant_topic_id4", void 0);
__decorate([
    editable()
], Topic.prototype, "relevant_topic_id5", void 0);
__decorate([
    editable()
], Topic.prototype, "relevant_topic_id6", void 0);
__decorate([
    editable()
], Topic.prototype, "relevant_topic_id7", void 0);
__decorate([
    editable()
], Topic.prototype, "relevant_topic_id8", void 0);
__decorate([
    editable()
], Topic.prototype, "relevant_topic_id9", void 0);
__decorate([
    editable()
], Topic.prototype, "relevant_topic_id10", void 0);
__decorate([
    editable()
], Topic.prototype, "isPremium", void 0);
__decorate([
    editable()
], Topic.prototype, "isSpeech", void 0);
__decorate([
    memoize
], Topic.prototype, "topicMicroQuestions", null);
__decorate([
    memoize
], Topic.prototype, "topicMiniQuestions", null);
__decorate([
    memoize
], Topic.prototype, "topicMiniQuestionsHidden", null);
__decorate([
    memoize
], Topic.prototype, "topicSubtopics", null);
__decorate([
    memoize
], Topic.prototype, "topicFilter", null);
__decorate([
    memoize
], Topic.prototype, "topicLevels", null);
__decorate([
    memoize
], Topic.prototype, "topicInfo", null);
__decorate([
    memoize
], Topic.prototype, "topicEdit", null);
__decorate([
    computed
], Topic.prototype, "packages", null);
__decorate([
    computed
], Topic.prototype, "bundlesAuto", null);
__decorate([
    computed
], Topic.prototype, "bundleNamesAuto", null);
__decorate([
    computed
], Topic.prototype, "hiddenInApp", null);
__decorate([
    memoize
], Topic, "serializeInfo", null);
